export const RewardAlreadyGotit = 'RewardAlreadyGotit';
